/*eslint-disable */
const $ = window.jQuery = require('jquery');

import addReserachGroup from './add-research-group';
import {bus} from '@/main';
import toast from '@/services/toast';
import updateReserachGroup from './update-research-group-detail';

export default {
  name: 'research-group-list',
  components: {
    'add-reserach-group' : addReserachGroup,
    'update-reserach-group' : updateReserachGroup
  },
  props: [],
  data () {
    return {
      researchGroupList:{},
      researchGroupListResults:[],
      nextSteper:'',
      nextPageUrl:'',
      addResearchGroupPopupState:false,
      updateResearchGroupPopupState:false,
      updateResearchGroupPopupId:'',
      removeRGroupPopupState:false,
      removeRGroupPopupId:'',
      selfUserInfo:null,
      accessFeaturesOfPackageState:false
    }
  },
  computed: {
  },
  mounted () {
    bus.$on('addResearchGroupPopupStateBus', (data) => {
      this.addResearchGroupPopupState = data;
    });
    bus.$on('updateResearchGroupPopupStateBus', (data) => {
      this.updateResearchGroupPopupState = data;
    });
    bus.$on('accessFeaturesOfPackageStateBus', (data) => {
      this.accessFeaturesOfPackageState = data;
    });
  },
  methods: {
    accessFeaturesOfPackagemethod(){
      this.accessFeaturesOfPackageState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    getResearchGroupListAgain(){
      this.$store.dispatch('getResearchGroupListFun')
    },
    openPopupOfAddResearchGroup(){
      this.addResearchGroupPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    updateAwerackRGroupInfoMethod(itemId){
      this.updateResearchGroupPopupState = true
      this.updateResearchGroupPopupId = itemId
      $('body').addClass('body_right_scroll_remove')
    },
    removeRGroupMethod(itemId){
      this.removeRGroupPopupState = true
      this.removeRGroupPopupId = itemId
      $('body').addClass('body_right_scroll_remove')
    },
    removeConfirmRGroupMethod(){
      this.$store.dispatch('removeAwerackPaperFun',{id:this.removeRGroupPopupId}).then((res)=>{
        toast.success(res.data.msg);
        this.closeRemoveRGroupMethod()
        this.getResearchGroupListAgain()
      }).catch((err)=>{
      })
    },
    closeRemoveRGroupMethod(){
      this.removeRGroupPopupState = false
      this.removeRGroupPopupId = ''
      $('body').removeClass('body_right_scroll_remove')
    }
  },
  watch:{
  },
}